export const Areas = [
  {
    id: '11',
    name: '北京',
    children: [
      {
        id: '1101',
        name: '北京市',
      },
    ],
  },
  {
    id: '12',
    name: '天津',
    children: [
      {
        id: '1201',
        name: '天津市',
      },
    ],
  },
  {
    id: '13',
    name: '河北省',
    children: [
      {
        id: '1301',
        name: '石家庄市',
      },
      {
        id: '1302',
        name: '唐山市',
      },
      {
        id: '1303',
        name: '秦皇岛市',
      },
      {
        id: '1304',
        name: '邯郸市',
      },
      {
        id: '1305',
        name: '邢台市',
      },
      {
        id: '1306',
        name: '保定市',
      },
      {
        id: '1307',
        name: '张家口市',
      },
      {
        id: '1308',
        name: '承德市',
      },
      {
        id: '1309',
        name: '沧州市',
      },
      {
        id: '1310',
        name: '廊坊市',
      },
      {
        id: '1311',
        name: '衡水市',
      },
    ],
  },
  {
    id: '14',
    name: '山西省',
    children: [
      {
        id: '1401',
        name: '太原市',
      },
      {
        id: '1402',
        name: '大同市',
      },
      {
        id: '1403',
        name: '阳泉市',
      },
      {
        id: '1404',
        name: '长治市',
      },
      {
        id: '1405',
        name: '晋城市',
      },
      {
        id: '1406',
        name: '朔州市',
      },
      {
        id: '1407',
        name: '晋中市',
      },
      {
        id: '1408',
        name: '运城市',
      },
      {
        id: '1409',
        name: '忻州市',
      },
      {
        id: '1410',
        name: '临汾市',
      },
      {
        id: '1411',
        name: '吕梁市',
      },
    ],
  },
  {
    id: '15',
    name: '内蒙古自治区',
    children: [
      {
        id: '1501',
        name: '呼和浩特市',
      },
      {
        id: '1502',
        name: '包头市',
      },
      {
        id: '1503',
        name: '乌海市',
      },
      {
        id: '1504',
        name: '赤峰市',
      },
      {
        id: '1505',
        name: '通辽市',
      },
      {
        id: '1506',
        name: '鄂尔多斯市',
      },
      {
        id: '1507',
        name: '呼伦贝尔市',
      },
      {
        id: '1508',
        name: '巴彦淖尔市',
      },
      {
        id: '1509',
        name: '乌兰察布市',
      },
      {
        id: '1522',
        name: '兴安盟',
      },
      {
        id: '1525',
        name: '锡林郭勒盟',
      },
      {
        id: '1529',
        name: '阿拉善盟',
      },
    ],
  },
  {
    id: '21',
    name: '辽宁省',
    children: [
      {
        id: '2101',
        name: '沈阳市',
      },
      {
        id: '2102',
        name: '大连市',
      },
      {
        id: '2103',
        name: '鞍山市',
      },
      {
        id: '2104',
        name: '抚顺市',
      },
      {
        id: '2105',
        name: '本溪市',
      },
      {
        id: '2106',
        name: '丹东市',
      },
      {
        id: '2107',
        name: '锦州市',
      },
      {
        id: '2108',
        name: '营口市',
      },
      {
        id: '2109',
        name: '阜新市',
      },
      {
        id: '2110',
        name: '辽阳市',
      },
      {
        id: '2111',
        name: '盘锦市',
      },
      {
        id: '2112',
        name: '铁岭市',
      },
      {
        id: '2113',
        name: '朝阳市',
      },
      {
        id: '2114',
        name: '葫芦岛市',
      },
    ],
  },
  {
    id: '22',
    name: '吉林省',
    children: [
      {
        id: '2201',
        name: '长春市',
      },
      {
        id: '2202',
        name: '吉林市',
      },
      {
        id: '2203',
        name: '四平市',
      },
      {
        id: '2204',
        name: '辽源市',
      },
      {
        id: '2205',
        name: '通化市',
      },
      {
        id: '2206',
        name: '白山市',
      },
      {
        id: '2207',
        name: '松原市',
      },
      {
        id: '2208',
        name: '白城市',
      },
      {
        id: '2224',
        name: '延边朝鲜族自治州',
      },
    ],
  },
  {
    id: '23',
    name: '黑龙江省',
    children: [
      {
        id: '2301',
        name: '哈尔滨市',
      },
      {
        id: '2302',
        name: '齐齐哈尔市',
      },
      {
        id: '2303',
        name: '鸡西市',
      },
      {
        id: '2304',
        name: '鹤岗市',
      },
      {
        id: '2305',
        name: '双鸭山市',
      },
      {
        id: '2306',
        name: '大庆市',
      },
      {
        id: '2307',
        name: '伊春市',
      },
      {
        id: '2308',
        name: '佳木斯市',
      },
      {
        id: '2309',
        name: '七台河市',
      },
      {
        id: '2310',
        name: '牡丹江市',
      },
      {
        id: '2311',
        name: '黑河市',
      },
      {
        id: '2312',
        name: '绥化市',
      },
      {
        id: '2327',
        name: '大兴安岭地区',
      },
    ],
  },
  {
    id: '31',
    name: '上海',
    children: [
      {
        id: '3101',
        name: '上海市',
      },
    ],
  },
  {
    id: '32',
    name: '江苏省',
    children: [
      {
        id: '3201',
        name: '南京市',
      },
      {
        id: '3202',
        name: '无锡市',
      },
      {
        id: '3203',
        name: '徐州市',
      },
      {
        id: '3204',
        name: '常州市',
      },
      {
        id: '3205',
        name: '苏州市',
      },
      {
        id: '3206',
        name: '南通市',
      },
      {
        id: '3207',
        name: '连云港市',
      },
      {
        id: '3208',
        name: '淮安市',
      },
      {
        id: '3209',
        name: '盐城市',
      },
      {
        id: '3210',
        name: '扬州市',
      },
      {
        id: '3211',
        name: '镇江市',
      },
      {
        id: '3212',
        name: '泰州市',
      },
      {
        id: '3213',
        name: '宿迁市',
      },
    ],
  },
  {
    id: '33',
    name: '浙江省',
    children: [
      {
        id: '3301',
        name: '杭州市',
      },
      {
        id: '3302',
        name: '宁波市',
      },
      {
        id: '3303',
        name: '温州市',
      },
      {
        id: '3304',
        name: '嘉兴市',
      },
      {
        id: '3305',
        name: '湖州市',
      },
      {
        id: '3306',
        name: '绍兴市',
      },
      {
        id: '3307',
        name: '金华市',
      },
      {
        id: '3308',
        name: '衢州市',
      },
      {
        id: '3309',
        name: '舟山市',
      },
      {
        id: '3310',
        name: '台州市',
      },
      {
        id: '3311',
        name: '丽水市',
      },
    ],
  },
  {
    id: '34',
    name: '安徽省',
    children: [
      {
        id: '3401',
        name: '合肥市',
      },
      {
        id: '3402',
        name: '芜湖市',
      },
      {
        id: '3403',
        name: '蚌埠市',
      },
      {
        id: '3404',
        name: '淮南市',
      },
      {
        id: '3405',
        name: '马鞍山市',
      },
      {
        id: '3406',
        name: '淮北市',
      },
      {
        id: '3407',
        name: '铜陵市',
      },
      {
        id: '3408',
        name: '安庆市',
      },
      {
        id: '3410',
        name: '黄山市',
      },
      {
        id: '3411',
        name: '滁州市',
      },
      {
        id: '3412',
        name: '阜阳市',
      },
      {
        id: '3413',
        name: '宿州市',
      },
      {
        id: '3415',
        name: '六安市',
      },
      {
        id: '3416',
        name: '亳州市',
      },
      {
        id: '3417',
        name: '池州市',
      },
      {
        id: '3418',
        name: '宣城市',
      },
    ],
  },
  {
    id: '35',
    name: '福建省',
    children: [
      {
        id: '3501',
        name: '福州市',
      },
      {
        id: '3502',
        name: '厦门市',
      },
      {
        id: '3503',
        name: '莆田市',
      },
      {
        id: '3504',
        name: '三明市',
      },
      {
        id: '3505',
        name: '泉州市',
      },
      {
        id: '3506',
        name: '漳州市',
      },
      {
        id: '3507',
        name: '南平市',
      },
      {
        id: '3508',
        name: '龙岩市',
      },
      {
        id: '3509',
        name: '宁德市',
      },
    ],
  },
  {
    id: '36',
    name: '江西省',
    children: [
      {
        id: '3601',
        name: '南昌市',
      },
      {
        id: '3602',
        name: '景德镇市',
      },
      {
        id: '3603',
        name: '萍乡市',
      },
      {
        id: '3604',
        name: '九江市',
      },
      {
        id: '3605',
        name: '新余市',
      },
      {
        id: '3606',
        name: '鹰潭市',
      },
      {
        id: '3607',
        name: '赣州市',
      },
      {
        id: '3608',
        name: '吉安市',
      },
      {
        id: '3609',
        name: '宜春市',
      },
      {
        id: '3610',
        name: '抚州市',
      },
      {
        id: '3611',
        name: '上饶市',
      },
    ],
  },
  {
    id: '37',
    name: '山东省',
    children: [
      {
        id: '3701',
        name: '济南市',
      },
      {
        id: '3702',
        name: '青岛市',
      },
      {
        id: '3703',
        name: '淄博市',
      },
      {
        id: '3704',
        name: '枣庄市',
      },
      {
        id: '3705',
        name: '东营市',
      },
      {
        id: '3706',
        name: '烟台市',
      },
      {
        id: '3707',
        name: '潍坊市',
      },
      {
        id: '3708',
        name: '济宁市',
      },
      {
        id: '3709',
        name: '泰安市',
      },
      {
        id: '3710',
        name: '威海市',
      },
      {
        id: '3711',
        name: '日照市',
      },
      {
        id: '3712',
        name: '莱芜市',
      },
      {
        id: '3713',
        name: '临沂市',
      },
      {
        id: '3714',
        name: '德州市',
      },
      {
        id: '3715',
        name: '聊城市',
      },
      {
        id: '3716',
        name: '滨州市',
      },
      {
        id: '3717',
        name: '菏泽市',
      },
    ],
  },
  {
    id: '41',
    name: '河南省',
    children: [
      {
        id: '4101',
        name: '郑州市',
      },
      {
        id: '4102',
        name: '开封市',
      },
      {
        id: '4103',
        name: '洛阳市',
      },
      {
        id: '4104',
        name: '平顶山市',
      },
      {
        id: '4105',
        name: '安阳市',
      },
      {
        id: '4106',
        name: '鹤壁市',
      },
      {
        id: '4107',
        name: '新乡市',
      },
      {
        id: '4108',
        name: '焦作市',
      },
      {
        id: '4109',
        name: '濮阳市',
      },
      {
        id: '4110',
        name: '许昌市',
      },
      {
        id: '4111',
        name: '漯河市',
      },
      {
        id: '4112',
        name: '三门峡市',
      },
      {
        id: '4113',
        name: '南阳市',
      },
      {
        id: '4114',
        name: '商丘市',
      },
      {
        id: '4115',
        name: '信阳市',
      },
      {
        id: '4116',
        name: '周口市',
      },
      {
        id: '4117',
        name: '驻马店市',
      },
    ],
  },
  {
    id: '42',
    name: '湖北省',
    children: [
      {
        id: '4201',
        name: '武汉市',
      },
      {
        id: '4202',
        name: '黄石市',
      },
      {
        id: '4203',
        name: '十堰市',
      },
      {
        id: '4205',
        name: '宜昌市',
      },
      {
        id: '4206',
        name: '襄阳市',
      },
      {
        id: '4207',
        name: '鄂州市',
      },
      {
        id: '4209',
        name: '孝感市',
      },
      {
        id: '4210',
        name: '荆州市',
      },
      {
        id: '4211',
        name: '黄冈市',
      },
      {
        id: '4212',
        name: '咸宁市',
      },
      {
        id: '4213',
        name: '随州市',
      },
      {
        id: '4228',
        name: '恩施土家族苗族自治州',
      },
    ],
  },
  {
    id: '43',
    name: '湖南省',
    children: [
      {
        id: '4301',
        name: '长沙市',
      },
      {
        id: '4302',
        name: '株洲市',
      },
      {
        id: '4303',
        name: '湘潭市',
      },
      {
        id: '4304',
        name: '衡阳市',
      },
      {
        id: '4305',
        name: '邵阳市',
      },
      {
        id: '4306',
        name: '岳阳市',
      },
      {
        id: '4307',
        name: '常德市',
      },
      {
        id: '4308',
        name: '张家界市',
      },
      {
        id: '4309',
        name: '益阳市',
      },
      {
        id: '4310',
        name: '郴州市',
      },
      {
        id: '4311',
        name: '永州市',
      },
      {
        id: '4312',
        name: '怀化市',
      },
      {
        id: '4313',
        name: '娄底市',
      },
      {
        id: '4331',
        name: '湘西土家族苗族自治州',
      },
    ],
  },
  {
    id: '44',
    name: '广东省',
    children: [
      {
        id: '4401',
        name: '广州市',
      },
      {
        id: '4402',
        name: '韶关市',
      },
      {
        id: '4403',
        name: '深圳市',
      },
      {
        id: '4404',
        name: '珠海市',
      },
      {
        id: '4405',
        name: '汕头市',
      },
      {
        id: '4406',
        name: '佛山市',
      },
      {
        id: '4407',
        name: '江门市',
      },
      {
        id: '4408',
        name: '湛江市',
      },
      {
        id: '4409',
        name: '茂名市',
      },
      {
        id: '4412',
        name: '肇庆市',
      },
      {
        id: '4413',
        name: '惠州市',
      },
      {
        id: '4414',
        name: '梅州市',
      },
      {
        id: '4415',
        name: '汕尾市',
      },
      {
        id: '4416',
        name: '河源市',
      },
      {
        id: '4417',
        name: '阳江市',
      },
      {
        id: '4418',
        name: '清远市',
      },
      {
        id: '4451',
        name: '潮州市',
      },
      {
        id: '4452',
        name: '揭阳市',
      },
      {
        id: '4453',
        name: '云浮市',
      },
    ],
  },
  {
    id: '45',
    name: '广西壮族自治区',
    children: [
      {
        id: '4501',
        name: '南宁市',
      },
      {
        id: '4502',
        name: '柳州市',
      },
      {
        id: '4503',
        name: '桂林市',
      },
      {
        id: '4504',
        name: '梧州市',
      },
      {
        id: '4505',
        name: '北海市',
      },
      {
        id: '4506',
        name: '防城港市',
      },
      {
        id: '4507',
        name: '钦州市',
      },
      {
        id: '4508',
        name: '贵港市',
      },
      {
        id: '4509',
        name: '玉林市',
      },
      {
        id: '4510',
        name: '百色市',
      },
      {
        id: '4511',
        name: '贺州市',
      },
      {
        id: '4512',
        name: '河池市',
      },
      {
        id: '4513',
        name: '来宾市',
      },
      {
        id: '4514',
        name: '崇左市',
      },
    ],
  },
  {
    id: '46',
    name: '海南省',
    children: [
      {
        id: '4601',
        name: '海口市',
      },
      {
        id: '4603',
        name: '三沙市',
      },
    ],
  },
  {
    id: '50',
    name: '重庆',
    children: [
      {
        id: '5001',
        name: '重庆市',
      },
    ],
  },
  {
    id: '51',
    name: '四川省',
    children: [
      {
        id: '5101',
        name: '成都市',
      },
      {
        id: '5103',
        name: '自贡市',
      },
      {
        id: '5104',
        name: '攀枝花市',
      },
      {
        id: '5105',
        name: '泸州市',
      },
      {
        id: '5106',
        name: '德阳市',
      },
      {
        id: '5107',
        name: '绵阳市',
      },
      {
        id: '5108',
        name: '广元市',
      },
      {
        id: '5109',
        name: '遂宁市',
      },
      {
        id: '5110',
        name: '内江市',
      },
      {
        id: '5111',
        name: '乐山市',
      },
      {
        id: '5113',
        name: '南充市',
      },
      {
        id: '5114',
        name: '眉山市',
      },
      {
        id: '5115',
        name: '宜宾市',
      },
      {
        id: '5116',
        name: '广安市',
      },
      {
        id: '5117',
        name: '达州市',
      },
      {
        id: '5118',
        name: '雅安市',
      },
      {
        id: '5119',
        name: '巴中市',
      },
      {
        id: '5120',
        name: '资阳市',
      },
      {
        id: '5132',
        name: '阿坝藏族羌族自治州',
      },
      {
        id: '5133',
        name: '甘孜藏族自治州',
      },
      {
        id: '5134',
        name: '凉山彝族自治州',
      },
    ],
  },
  {
    id: '52',
    name: '贵州省',
    children: [
      {
        id: '5201',
        name: '贵阳市',
      },
      {
        id: '5202',
        name: '六盘水市',
      },
      {
        id: '5203',
        name: '遵义市',
      },
      {
        id: '5204',
        name: '安顺市',
      },
      {
        id: '5205',
        name: '毕节市',
      },
      {
        id: '5206',
        name: '铜仁市',
      },
      {
        id: '5223',
        name: '黔西南布依族苗族自治州',
      },
      {
        id: '5226',
        name: '黔东南苗族侗族自治州',
      },
      {
        id: '5227',
        name: '黔南布依族苗族自治州',
      },
    ],
  },
  {
    id: '53',
    name: '云南省',
    children: [
      {
        id: '5301',
        name: '昆明市',
      },
      {
        id: '5303',
        name: '曲靖市',
      },
      {
        id: '5304',
        name: '玉溪市',
      },
      {
        id: '5305',
        name: '保山市',
      },
      {
        id: '5306',
        name: '昭通市',
      },
      {
        id: '5307',
        name: '丽江市',
      },
      {
        id: '5308',
        name: '普洱市',
      },
      {
        id: '5309',
        name: '临沧市',
      },
      {
        id: '5323',
        name: '楚雄彝族自治州',
      },
      {
        id: '5325',
        name: '红河哈尼族彝族自治州',
      },
      {
        id: '5326',
        name: '文山壮族苗族自治州',
      },
      {
        id: '5328',
        name: '西双版纳傣族自治州',
      },
      {
        id: '5329',
        name: '大理白族自治州',
      },
      {
        id: '5331',
        name: '德宏傣族景颇族自治州',
      },
      {
        id: '5333',
        name: '怒江傈僳族自治州',
      },
      {
        id: '5334',
        name: '迪庆藏族自治州',
      },
    ],
  },
  {
    id: '54',
    name: '西藏自治区',
    children: [
      {
        id: '5401',
        name: '拉萨市',
      },
      {
        id: '5421',
        name: '昌都地区',
      },
      {
        id: '5422',
        name: '山南地区',
      },
      {
        id: '5423',
        name: '日喀则地区',
      },
      {
        id: '5424',
        name: '那曲地区',
      },
      {
        id: '5425',
        name: '阿里地区',
      },
      {
        id: '5426',
        name: '林芝地区',
      },
    ],
  },
  {
    id: '61',
    name: '陕西省',
    children: [
      {
        id: '6101',
        name: '西安市',
      },
      {
        id: '6102',
        name: '铜川市',
      },
      {
        id: '6103',
        name: '宝鸡市',
      },
      {
        id: '6104',
        name: '咸阳市',
      },
      {
        id: '6105',
        name: '渭南市',
      },
      {
        id: '6106',
        name: '延安市',
      },
      {
        id: '6107',
        name: '汉中市',
      },
      {
        id: '6108',
        name: '榆林市',
      },
      {
        id: '6109',
        name: '安康市',
      },
      {
        id: '6110',
        name: '商洛市',
      },
    ],
  },
  {
    id: '62',
    name: '甘肃省',
    children: [
      {
        id: '6201',
        name: '兰州市',
      },
      {
        id: '6203',
        name: '金昌市',
      },
      {
        id: '6204',
        name: '白银市',
      },
      {
        id: '6205',
        name: '天水市',
      },
      {
        id: '6206',
        name: '武威市',
      },
      {
        id: '6207',
        name: '张掖市',
      },
      {
        id: '6208',
        name: '平凉市',
      },
      {
        id: '6209',
        name: '酒泉市',
      },
      {
        id: '6210',
        name: '庆阳市',
      },
      {
        id: '6211',
        name: '定西市',
      },
      {
        id: '6212',
        name: '陇南市',
      },
      {
        id: '6229',
        name: '临夏回族自治州',
      },
      {
        id: '6230',
        name: '甘南藏族自治州',
      },
    ],
  },
  {
    id: '63',
    name: '青海省',
    children: [
      {
        id: '6301',
        name: '西宁市',
      },
      {
        id: '6321',
        name: '海东地区',
      },
      {
        id: '6322',
        name: '海北藏族自治州',
      },
      {
        id: '6323',
        name: '黄南藏族自治州',
      },
      {
        id: '6325',
        name: '海南藏族自治州',
      },
      {
        id: '6326',
        name: '果洛藏族自治州',
      },
      {
        id: '6327',
        name: '玉树藏族自治州',
      },
      {
        id: '6328',
        name: '海西蒙古族藏族自治州',
      },
    ],
  },
  {
    id: '64',
    name: '宁夏回族自治区',
    children: [
      {
        id: '6401',
        name: '银川市',
      },
      {
        id: '6402',
        name: '石嘴山市',
      },
      {
        id: '6403',
        name: '吴忠市',
      },
      {
        id: '6404',
        name: '固原市',
      },
      {
        id: '6405',
        name: '中卫市',
      },
    ],
  },
  {
    id: '65',
    name: '新疆维吾尔自治区',
    children: [
      {
        id: '6501',
        name: '乌鲁木齐市',
      },
      {
        id: '6502',
        name: '克拉玛依市',
      },
      {
        id: '6521',
        name: '吐鲁番地区',
      },
      {
        id: '6522',
        name: '哈密地区',
      },
      {
        id: '6523',
        name: '昌吉回族自治州',
      },
      {
        id: '6527',
        name: '博尔塔拉蒙古自治州',
      },
      {
        id: '6528',
        name: '巴音郭楞蒙古自治州',
      },
      {
        id: '6529',
        name: '阿克苏地区',
      },
      {
        id: '6530',
        name: '克孜勒苏柯尔克孜自治州',
      },
      {
        id: '6531',
        name: '喀什地区',
      },
      {
        id: '6532',
        name: '和田地区',
      },
      {
        id: '6540',
        name: '伊犁哈萨克自治州',
      },
      {
        id: '6542',
        name: '塔城地区',
      },
      {
        id: '6543',
        name: '阿勒泰地区',
      },
    ],
  },
  {
    id: '71',
    name: '台湾省',
    children: [
      {
        id: '7101',
        name: '台北市',
      },
      {
        id: '7102',
        name: '高雄市',
      },
      {
        id: '7103',
        name: '台南市',
      },
      {
        id: '7104',
        name: '台中市',
      },
      {
        id: '7107',
        name: '基隆市',
      },
      {
        id: '7108',
        name: '新竹市',
      },
      {
        id: '7109',
        name: '嘉义市',
      },
    ],
  },
  {
    id: '81',
    name: '香港特别行政区',
    children: [
      {
        id: '8101',
        name: '香港岛',
      },
      {
        id: '8102',
        name: '九龙',
      },
      {
        id: '8103',
        name: '新界',
      },
    ],
  },
  {
    id: '82',
    name: '澳门特别行政区',
    children: [
      {
        id: '8201',
        name: '澳门特别行政区',
      },
    ],
  },
  // {
  //   id: '99',
  //   name: '海外',
  //   children: []
  // }
];
